'use client'

import React from 'react'
import { cn } from '@/utilities/ui'
import { Heading } from '@/components/ui/heading'
import { Caption } from '@/components/ui/caption'
import { EyebrowItem } from '@/components/EyebrowItem'
import { ShardGrid } from '@/components/ShardGrid'
import { Color, colorToBackgroundClass } from '@/utilities/colors'
import { RichTextType } from '@/utilities/types'

export type SetupStepsProps = {
  steps: {
    id: string
    heading: string
    time: string
    color: Color
    subSteps: {
      heading: string
      description: RichTextType
    }[]
  }[]
}

export const SetupSteps: React.FC<SetupStepsProps> = ({ steps }) => {
  return (
    <div className="xl:flex-1 flex flex-col gap-[30px]">
      {steps.map((step, stepIndex) => (
        <div key={step.id} className="bg-paper-1">
          <div
            className={cn(
              'flex justify-between items-center px-[20px] py-[16px]',
              colorToBackgroundClass[step.color],
            )}
          >
            <Heading size="h4" className="text-olive-2">
              {step.heading}
            </Heading>
            <Caption className="text-olive-2 font-bold text-[20px]">{step.time}</Caption>
          </div>

          <div className="flex flex-col lg:flex-row gap-x-[30px] px-[30px] gap-y-[30px] py-[30px]">
            {step.subSteps.map((subStep) => (
              <div key={subStep.heading} className="flex-1">
                <EyebrowItem
                  label={subStep.heading}
                  description={subStep.description}
                  color={step.color}
                  className="max-w-[600px]"
                />
              </div>
            ))}
            {stepIndex === 1 && step.subSteps.length < 2 && (
              <div className="flex-1 overflow-hidden">
                <ShardGrid />
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}
